module.exports = __webpack_public_path__ + "img/subBanner16.30b9fce0.png";